import PptxGenJS from "pptxgenjs"
import { splitTextInRect } from 'shared/util'

import { slideFrom } from '../util/slideFrom'
import { KojinPptxComponentsProps } from '../types'

const attributesLayout = {
  width: 4.29,
  captionWidth: 0.8
}
const lineHeight = 0.2
const marginWidth = 0.1
const marginHeight = 0.05

const borderColor = 'ffffff'
const headerBackground = '4C4948'
const headerText = 'ffffff'
const dataBackground = 'D9D9D9'
const dataText = '000000'

type attributesProps = KojinPptxComponentsProps & {
  top: number
}
type attributesReturnValue = {
	slide: PptxGenJS.Slide
  bottom: number
}
export const attributes = ({
  top,
  ...other
}: attributesProps): attributesReturnValue => {
  const { layout, slide, kojin } = other
  if (!kojin) return { slide, bottom: top }

  const attrRows = []
  if (kojin.sotukouName) {
    attrRows.push({
      title: '卒業校',
      data: kojin.sotugyouYear ? 
        [kojin.sotukouName, `${kojin.sotugyouYear}年卒`] :
        [kojin.sotukouName]
    })
  }
  if (kojin.sinryoka && kojin.sinryoka.length > 0) {
    attrRows.push({
      title: '診療科',
      data: kojin.sinryoka.map((sinryoka) => sinryoka.sinryokaName)
    })
  }
  if (kojin.senmoni && kojin.senmoni.length > 0) {
    attrRows.push({
      title: '専門医',
      data: kojin.senmoni.map((senmoni) => {
        let name = senmoni.senmoniName ?? ''
        const suffix = []
        if (senmoni.sidoui) suffix.push('指導医')
        if (senmoni.senmoni) suffix.push('専門医')
        if (senmoni.ninteii) suffix.push('認定医')
        if (suffix.length > 0) {
          name = (name.endsWith('専門医') ? name.substring(0, name.length - 3) : name) + suffix.join('／')
        }
        return name
      })
    })
  }
  if (kojin.gakkai && kojin.gakkai.length > 0) {
    attrRows.push({
      title: '学会',
      data: kojin.gakkai.map((gakkai) => gakkai.gakkaiName)
    })
  }
  if (attrRows.length === 0) return { slide, bottom: top }

  const rows = attrRows.map((row) => {
    if (row.title) {
      return [{
        text: row.title,
        width: attributesLayout.captionWidth,
        options: {
          ...layout.cellOption,
          color: headerText,
          fill: { color: headerBackground },
          align: 'center'
        },
      }, {
        text: row.data.join('　'),
        width: attributesLayout.width - attributesLayout.captionWidth,
        options: {
          ...layout.cellOption,
          color: dataText,
          fill: { color: dataBackground }
        }
      }]
    } else {
      return [{
        text: row.data.join('　'),
        width: attributesLayout.width,
        options: {
          ...layout.cellOption, 
          colspan: 2,
          color: dataText,
          fill: { color: dataBackground }
        }
      }]
    }
  })
  const height = rows.reduce((h, row) => {
    const rowHeight = row.reduce((h, col) => {
      const lines = splitTextInRect(
        col.text, layout.baseFont.fontSize, layout.baseFont.fontFace, 
        (col.width - (marginWidth + marginWidth)) * layout.inchPerDot
      ) || []
      return Math.max(h, marginHeight + (lineHeight * Math.max(1, lines.length)) + marginHeight)
    }, 0)
    return h + rowHeight
  }, 0)

  slide.addTable(rows as PptxGenJS.TableRow[], {
    x: slideFrom(layout, 'right', attributesLayout.width),
    y: top + layout.margin, 
    colW: [
      attributesLayout.captionWidth,
      attributesLayout.width - attributesLayout.captionWidth
    ],
    border: { pt: 1, color: borderColor },
    align: 'left', valign: 'top'
  })
  return {
    slide,
    bottom: top + layout.margin + height
  }
}